<script setup>
import { ref, onMounted } from 'vue';
import { RouterLink } from 'vue-router';
import { useServiceStore } from '@/stores/serviceStore';
import { useRequestsStore } from "@/stores/storeRequests";
import { useFieldsStore } from "@/stores/storeFieldData";
import ServiceAuthPhone from '@/components/services_view/ServiceAuthPhone.vue';
import ServiceAuthSms from '@/components/services_view/ServiceAuthSms.vue';
import ServiceAuthData from '@/components/services_view/ServiceAuthData.vue';
import ServiceServices from '@/components/services_view/ServiceServices.vue';
import ServiceRentalCourt from '@/components/services_view/ServiceRentalCourt.vue';
import ServiceRentalInventory from '@/components/services_view/ServiceRentalInventory.vue';
import ServiceSelectDate from '@/components/services_view/ServiceSelectDate.vue';
import ServiceBookings from '@/components/services_view/ServiceBookings.vue';
import ServiceSuccess from '@/components/services_view/ServiceSuccess.vue';
import Loader from '@/components/ui/Loader.vue';
import { useRouter } from 'vue-router'

const router = useRouter()

const storeService = useServiceStore();
const storeRequests = useRequestsStore();
const storeField = useFieldsStore();

const closeService = () => {
	storeService.clearSessionCourtTimes()
	storeService.clearSessionSelectedCourt()
	storeService.goToScreen(storeService.screens.authPhone)
	storeRequests.responseOk = null
    resetFields()
}

const resetFields = () => {
    storeField.updateFields('phone', 'title', '')
    storeField.updateFields('phone', 'disabledBtn', false)
    storeField.updateFields('agreement', 'title', '')
    storeField.updateFields('agreement', 'disabledBtn', false)
	storeRequests.responseOk = null
	storeRequests.responseError = ''
}

onMounted(() => {
	
})

</script>
<template>
    <section class="services">	
		<div class="container">
			<div class="services__inner-close">
				<RouterLink class="services__close" to='/' @click="closeService">
					<svg width='90' height='90'><use href='#x'></use></svg>
				</RouterLink>			
			</div>
		</div>
		<!-- <Loader v-if="storeService.isScreenLoading"/> -->
		<!-- <template> -->
			<Transition name="slide-up" mode="out-in">
				<ServiceAuthPhone v-if="storeService.currentScreen === storeService.screens.authPhone"/>
				<ServiceAuthSms v-else-if="storeService.currentScreen === storeService.screens.authSms"/>
				<ServiceAuthData v-else-if="storeService.currentScreen === storeService.screens.authUserData"/>			
				<ServiceServices v-else-if="storeService.currentScreen === storeService.screens.services"/>			
				<ServiceRentalCourt v-else-if="storeService.currentScreen === storeService.screens.rentalCourt"/>			
				<ServiceRentalInventory v-else-if="storeService.currentScreen === storeService.screens.rentalInventory"/>			
				<ServiceSelectDate v-else-if="storeService.currentScreen === storeService.screens.selectDate"/>			
				<ServiceBookings v-else-if="storeService.currentScreen === storeService.screens.bookings"/>			
				<ServiceSuccess v-else-if="storeService.currentScreen === storeService.screens.success"/>			
			</Transition>		
		<!-- </template> -->
    </section>
</template>
<style lang='scss' scoped>

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>